import React from "react";
import { Box, List, ListItem } from "@mui/material";

const columnsData = [
    {
        fieldName: "id",
        name: "ID",

        hideCellValue: true,

        renderElement: (row, currentCellValue) => {
            return (
                <span>
                    {row.firstName}
                    <button>hello {currentCellValue}</button>
                </span>
            );
        },
    },
    { fieldName: "firstName", name: "First name" },
    { fieldName: "lastName", name: "Last name" },
    {
        fieldName: "age",
        name: "Age",
        type: "number",
        showSortIcon: true,
    },
];
const rowsData = [
    { id: 1, lastName: "Snow", firstName: "Jon", age: 35 },
    { id: 2, lastName: "Lannister", firstName: "Cersei", age: 42 },
    { id: 3, lastName: "Lannister", firstName: "Jaime", age: 45 },
    { id: 4, lastName: "Stark", firstName: "Arya", age: 16 },
    { id: 5, lastName: "Targaryen", firstName: "Daenerys", age: 20 },
];

/**
 * TableList -  Table List shows table row items as list in mobile view
 * @param {*} param0
 * @returns
 */
function MobileTableList({
    rows = rowsData,
    columns = columnsData,
    componentStyleProps = {
        tableListSx: {},
        tableListItemSx: {},
        tableListItemRowSx: {},
        tableListItemLeftCellSx: {},
        tableListItemRightCellSx: {},
    },
}) {
    return (
        <List
            sx={{
                backgroundColor: "background.paper",
                padding: 0,

                ...componentStyleProps.tableListSx,
            }}
        >
            {rows.map((cRow, index) => {
                return (
                    <ListItem
                        key={index}
                        sx={{
                            width: "100%",
                            backgroundColor: "#F8F9FA",
                            display: "flex",
                            flexDirection: "row",
                            marginBottom: "1rem",
                            flexWrap:'wrap',
                            padding: 0,

                            "&:last-child": {
                                marginBottom: "0",
                            },

                            ...componentStyleProps.tableListItemSx,
                        }}
                    >
                        {columns.map((cColumn) => {
                            if (cColumn?.hideItem) {
                                return <></>;
                            }
                            return (
                                <Box
                                    sx={{
                                        display: cColumn?.hideItem ? "none" : "flex",
                                        justifyContent: "start",
                                        alignItems: "center",
                                        width: "100%",
                                        padding: "12px 24px",
                                        borderBottom: "1px solid #E9E9E9",

                                        "&:last-child": {
                                            borderBottom: "none",
                                        },
                                        ...componentStyleProps.tableListItemRowSx,
                                        ...cColumn?.listItemRowSx
                                    }}
                                >
                                    {!cColumn.hideLeftCell && (
                                        <Box
                                            sx={{
                                                color: "#101828",
                                                fontSize: "14px",
                                                fontWeight: 500,
                                                lineHeight: "18px" /* 128.571% */,
                                                marginRight: "0.8rem",

                                                ...componentStyleProps.tableListItemLeftCellSx,
                                            }}
                                        >
                                            {cColumn?.name}
                                            {cColumn.hideSeparater ? null : ":"}
                                        </Box>
                                    )}

                                    <Box
                                        sx={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "start",
                                            justifyContent: "center",

                                            color: "#374566",
                                            fontSize: "14px",
                                            fontWeight: 400,
                                            lineHeight: "20px" /* 142.857% */,

                                            ...componentStyleProps.tableListItemRightCellSx,
                                            ...cColumn.rightCellSx,
                                        }}
                                    >
                                        {!cColumn.hideCellValue && (typeof cRow[cColumn.fieldName] !== "object" || Array.isArray(cRow[cColumn.fieldName])) && cRow[cColumn.fieldName]}{" "}
                                        {cColumn.renderElement && cColumn.renderElement(cRow, cRow[cColumn.fieldName])}
                                    </Box>
                                </Box>
                            );
                        })}
                    </ListItem>
                );
            })}
        </List>
    );
}

export default MobileTableList;
